export class Article {
  constructor(public title:string,
              public isbn:string,
              public price:string,
              public category:string,
              public scale:string,
              public waterproof:boolean,
              public notes:string,
              public preorder:string,
              public imgTitle:string,
              public book_release:boolean) {
  }
}



// WEBPACK FOOTER //
// ./src/app/article/article.ts